import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { EscrowMembershipsDocument } from 'src/graphql/actions/escrowMemberships/escrowMemberships.query';
import { UsersDocument } from 'src/graphql/actions/user/users.query';

export const refetchEscrowMemberships = () => {
  client.cache.evict({ fieldName: 'escrowMemberships' });
  client.cache.gc();
  client.refetchQueries({
    include: [EscrowMembershipsDocument],
  });
};

export const refetchUsers = () => {
  client.cache.evict({ fieldName: 'users' });
  client.cache.gc();
  client.refetchQueries({
    include: [UsersDocument],
  });
};
